var showApamInformaModalExclusion = [];

$(document).on("click", ".show-apam-informa-modal", function() {

    if($(this).hasClass("show-apam-informa-modal-one-click")) {

        if(!inArray($(this).attr("data-route"), showApamInformaModalExclusion)) {
            addShowApamInformaModalExclusion($(this).attr("data-route"));
            $("#modal-apam-informa").modal("show");
            loadShowApamInformaModal($(this));
        }

    } else {
        loadShowApamInformaModal($(this));
    }
});

function loadShowApamInformaModal(element) {
    $("#modal-apam-informa").find(".modal-content").html("");
    $.get(Routing.generate("apam_informa_model_content", {
        "slug": element.attr("data-slug"),
        "route": element.attr("data-route"),
        "_": $.now()
    }), function(data) {
        $("#modal-apam-informa").find(".modal-content").html(data);
    });
}

function addShowApamInformaModalExclusion(route_id) {

    showApamInformaModalExclusion.push(route_id);
}